<script>
    import VTextField from 'vuetify/es5/components/VTextField/VTextField';
    import validations from "./validations";

    export default VTextField.extend({
        name: 'input-field',
        extends: VTextField,
        props: {
            outlined: { type: Boolean, default: true},
            rules: {
                default: function () {
                    return validations.checkEmail;
                }
            },
            type: {
                default: 'email'
            },
            "validate-on-blur":{
                default: true
            },
            "prepend-inner-icon": {
                default: 'fa-envelope'
            }
        }
    })

</script>
